export default __webpack_public_path__ + "static/media/icon-value-Collaboration.60ecb102.svg";